module.exports = __webpack_public_path__ + "img/材料力学6_7_2.4d5a5373.jpg";